const getVaultKeyListUrl = (searchTerm, limit, offset) => 
  `/api/v1/bg/vault/secrets?keyPrefix=${searchTerm}&limit=${limit}&offset=${offset}`;

export default getVaultKeyListUrl;
